import { render } from "./OtpCheck.vue?vue&type=template&id=78ae50be&scoped=true"
import script from "./OtpCheck.vue?vue&type=script&lang=js"
export * from "./OtpCheck.vue?vue&type=script&lang=js"

import "./OtpCheck.vue?vue&type=style&index=0&id=78ae50be&scoped=true&lang=css"
import "./OtpCheck.vue?vue&type=style&index=1&id=78ae50be&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ae50be"]])

export default __exports__